/*
 * @Author: fusiyuan 1152054863@qq.com
 * @Date: 2025-07-23 10:28:16
 * @LastEditors: fusiyuan 1152054863@qq.com
 * @LastEditTime: 2025-07-29 09:23:26
 * @FilePath: \slbq-web\reception\src\api\newApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { oauthRequestUrl as oauthUrl, requestUrl } from "@/config/config";

export const oauthCertification = `${oauthUrl}/oauth/certification`; // 认证

export const addSignContract = `${requestUrl}/works/signContract/add`; // 新增签约信息

export const getSignContract = `${requestUrl}/works/signContract/getSignContract`; // 查询签约信息

export const sendSignContract = `${requestUrl}/works/signContract/sendSignContract`;

export const getSignStatus = `${requestUrl}/works/signContract/getSignStatus`;

export const downloadSignContract = `${requestUrl}/works/signContract/downloadSignContract`;

export const getSignDataById = `${requestUrl}/works/signContract/getSignDataById`;

export const getSignContractStatus = `${requestUrl}/works/signContract/getSignContractStatus`; // 查询签约信息

export const signContractCancel = `${requestUrl}/works/signContract/cancel`; // 撤销合同接口
